module.exports = __webpack_public_path__ + "static/media/tips2-2.75a3f651.png";